export default "__VITE_ASSET__CKV0niI3__"